import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import PlusIcon from "../../../../assets/icons/PlusIcon";
import Spinner from "../../../../assets/icons/Spinner";
import Message from "../../../../i18n/Message";
import KBaseTile from "./KBaseTile";
import CreateKBaseDialog from "./CreateKBaseDialog";
import { loadKBases } from "../store/kbaseActionCreators";
import { kbaseSelectors } from "../store/kbaseReducer";

import "./KBaseListPage.scss";
import NewWorkspaceLayout from "../../layout/NewWorkspaceLayout";

const KBaseListPage = () => {
  const [showCreate, setShowCreate] = useState(false);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { workspaceId } = useParams();
  const kbaseList = useSelector(kbaseSelectors.getList);
  const listCounter = useSelector(kbaseSelectors.getListCounter);

  useEffect(() => {
    if (workspaceId) {
      dispatch(loadKBases(intl, workspaceId));
    }
  }, [dispatch, intl, workspaceId, listCounter]);

  return (
    <NewWorkspaceLayout contentPanelClassName="kbase_list_page">
      <div className="breadcrumbs">&nbsp;</div>
      <h1>
        <Message id="menu_knowledge" />
      </h1>
      <div className="actions_panel">
        <button
          className="btn btn-outline-dark"
          onClick={() => setShowCreate(true)}
        >
          <PlusIcon size="18" color="#344767" />
          <Message id="create_kbase" />
        </button>
      </div>
      <div className="body_content">
        <div className="campaign_tiles">
          {!kbaseList && <Spinner />}
          {kbaseList && kbaseList.length === 0 && (
            <div className="empty_state">
              <Message id="no_kbases_yet" />
            </div>
          )}
          {kbaseList &&
            kbaseList.map((kbase) => (
              <KBaseTile key={kbase.uid} kbase={kbase} />
            ))}
        </div>
      </div>
      {showCreate && <CreateKBaseDialog onClose={() => setShowCreate(false)} />}
    </NewWorkspaceLayout>
  );
};

export default KBaseListPage;
